export default "/assets/images/mila-feed-08-thumbnail.920c9825f10c08ca.jpg";